import React from 'react'
import styled, { type StyledComponent } from '@emotion/styled'
import { LinkProps, Link } from 'react-router'
import { hexColors } from '@mobi/settings/hexColors'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import { font, spacing } from '@mobi/component-library/Foundations'
import { trackSideMenuItemClick } from '@core/Areas/AppHeader/helpers/analytics'
import { store } from '@core/Store'
import { toggleIsHamburgerMenuOpen } from '@core/Areas/AppHeader/Store'

export const HamburgerMenuLink = ({ children, ...attribs }: LinkProps) => (
  <LinkStyled
    {...attribs}
    onClick={e => {
      store.dispatch(toggleIsHamburgerMenuOpen(false))
      trackSideMenuItemClick(attribs.id ?? '')
      attribs.onClick?.(e)
    }}
  >
    {children}
  </LinkStyled>
)

export const HamburgerMenuExternalLink = ({
  children,
  ...attribs
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <ExternalLinkStyled
    href={attribs.href}
    target='_blank'
    {...attribs}
    onClick={e => {
      trackSideMenuItemClick(attribs.id ?? '')
      attribs.onClick?.(e)
    }}
  >
    {children} <ExternalLinkIconStyled size='1em' type='externalLink' />
  </ExternalLinkStyled>
)

// ======
// Styles
// ======

const ExternalLinkStyled = styled.a({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx2,
  color: hexColors.blueDiamond,
  fontSize: '1.4rem',
  fontFamily: font.family.secondary,
  textDecoration: 'none',
  padding: '0.5em 0',

  em: {
    fontFamily: font.family.primary,
    fontSize: font.size.xs.fontSize,
    fontWeight: font.weight.bold,
    padding: '0.1rem 0.5rem',
    transform: 'translateY(-0.2rem)',
    fontStyle: 'italic',
    lineHeight: 1,
    textTransform: 'uppercase',
    borderRadius: '1rem',
    color: hexColors.white,
    background: hexColors.freeSpeechRed,
  },
})

const LinkStyled: StyledComponent<LinkProps> = styled(ExternalLinkStyled)().withComponent(Link)

const ExternalLinkIconStyled = styled(Icon)({
  verticalAlign: 'text-top',
  marginLeft: '0.5em',
  color: hexColors.deepLilac,
})
